import { LOCAL_STORAGE_TOKEN_KEY } from "../../ui/setup-view";
import { OAuthService } from "../oauth/oauth-service";
import { OAuthStore } from "../oauth/oauth-store";
export class LoginViewModel {
    name = this.constructor.name;
    constructor() {
    }
    get isOAuthEnabled() {
        return OAuthService.isOAuthEnabled;
    }
    get isOAuthAuthenticated() {
        return OAuthStore.getInstance().isAuthenticated();
    }
    get isTokenEnabled() {
        // for now, we only support either OAuth or token
        return !OAuthService.isOAuthEnabled;
    }
    get isTokenAvailable() {
        const key = localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY);
        return key !== null && key.length > 0;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    notifyLocationChanged(route, params) {
    }
}
